<script>
    export let headerTitle = "";
    export let headersubtitle = "";
    export let cardHeaderProps = "";
    export let contentBody = "";
    export let cardBodyProps = "";
    export let footercontent = "";
</script>

<div class="card">
    <div class="card-header {cardHeaderProps}">
        <h5>{headerTitle}</h5>
        {#if headersubtitle}
            <span>{headersubtitle}</span>
        {/if}
    </div>
    {#if cardBodyProps || contentBody}
        <div class="card-body {cardBodyProps}">
            <span>{contentBody}</span>
        </div>
    {/if}
    {#if $$slots.custombody}
        <div class="card-body">
            <slot name="custombody" />
        </div>
    {/if}
    {#if footercontent}
        <div class="card-footer">
            <h6 class="mb-0">{footercontent}</h6>
        </div>
    {/if}
</div>
